import get from 'lodash/get';
import { TECH_HIGHLIGHTS_MINIMAL_COUNTS } from '@yme/utils/constants';
import { TECH_HIGHLIGHTS_KEY } from './constants';
function getLocalizedValue(data, lang) {
    const langSecondOption = lang.replace(/-|_/g, '_');
    if (data[lang]) {
        return data[lang];
    }
    if (data[langSecondOption]) {
        return data[langSecondOption];
    }
    return data.en;
}
export function getTechHighlightsParameters({ itemVariant, language, }) {
    const techHighlightsParameters = itemVariant?.attributes?.find((item) => item?.name === TECH_HIGHLIGHTS_KEY);
    const finalData = techHighlightsParameters?.value?.reduce((acc = [], item) => {
        const title = get(item, 'title', undefined);
        const value = get(item, 'value', undefined);
        if (!title || !value) {
            return [];
        }
        const localTitle = getLocalizedValue(title, language);
        const localValue = getLocalizedValue(value, language);
        const itemOptions = {
            title: localTitle.trim(),
            value: localValue.trim(),
        };
        if (!acc.length) {
            return [itemOptions];
        }
        return [...acc, itemOptions];
    }, []);
    return finalData?.length >= TECH_HIGHLIGHTS_MINIMAL_COUNTS ? finalData.slice(0, 4) : [];
}
